"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Content;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("@paprika/helpers");

var _DOMAttributes = require("../../helpers/DOMAttributes");

var _handleKeyboardKeys = require("../../helpers/handleKeyboardKeys");

var _useListBox3 = _interopRequireDefault(require("../../useListBox"));

var _OnChangeProvider = require("../../store/OnChangeProvider");

var _PropsProvider = require("../../store/PropsProvider");

var sc = _interopRequireWildcard(require("./Content.styles"));

var _excluded = ["children", "onCancelFooter"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var handleBlur = function handleBlur(state, dispatch, onCancelFooter) {
  return function () {
    var refListBoxContainer = state.refListBoxContainer; // requestAnimationFrame give time to process
    // the element that has received the click event
    // via document.activeElement instead of returning
    // the body element automatically

    window.requestAnimationFrame(function () {
      var activeElement = (0, _helpers.getActiveElement)(); // in case the on blur happens on the trigger it should ignore it and let the trigger to control the flow of the
      // popover

      if (state.refTriggerContainer.current && state.refTriggerContainer.current.contains(activeElement)) {
        return;
      }

      if (refListBoxContainer && refListBoxContainer.current && !refListBoxContainer.current.contains(activeElement)) {
        dispatch({
          type: _useListBox3["default"].types.closePopover
        });

        if (state.hasFooter) {
          dispatch({
            type: _useListBox3["default"].types.cancel
          });
          if (onCancelFooter) onCancelFooter();
        }
      }
    });
  };
};

function Content(props) {
  var children = props.children,
      onCancelFooter = props.onCancelFooter,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);

  var onChangeContext = _react["default"].useContext(_OnChangeProvider.OnChangeContext);

  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      state = _useListBox2[0],
      dispatch = _useListBox2[1];

  var refListBoxContainer = state.refListBoxContainer;

  var providedProps = _react["default"].useContext(_PropsProvider.PropsContext);

  var a11yProps = providedProps.a11yProps,
      idListBox = providedProps.idListBox,
      isInline = providedProps.isInline,
      refLabel = providedProps.refLabel,
      contentOffsetX = providedProps.contentOffsetX,
      contentOffsetY = providedProps.contentOffsetY;

  if (isInline) {
    return /*#__PURE__*/_react["default"].createElement(sc.Content, (0, _extends2["default"])({}, a11yProps, moreProps, (0, _DOMAttributes.getDOMAttributesForListBox)(_objectSpread({
      idListBox: idListBox,
      refLabel: refLabel
    }, state)), {
      "data-pka-anchor": "list-box-content-inline" // TODO: rename "list-box.content-inline"
      ,
      onKeyDown: (0, _handleKeyboardKeys.handleKeyDownKeyboardKeys)({
        providedProps: providedProps,
        state: state,
        dispatch: dispatch,
        onChangeContext: onChangeContext
      }),
      ref: refListBoxContainer,
      role: "listbox",
      tabIndex: "0"
    }), children);
  }

  return /*#__PURE__*/_react["default"].createElement(sc.PopoverContent, (0, _extends2["default"])({}, moreProps, (0, _DOMAttributes.getDOMAttributesForListBox)(_objectSpread({
    idListBox: idListBox,
    refLabel: refLabel
  }, state)), {
    contentOffsetX: contentOffsetX,
    contentOffsetY: contentOffsetY,
    onBlur: handleBlur(state, dispatch, onCancelFooter),
    onKeyDown: (0, _handleKeyboardKeys.handleKeyDownKeyboardKeys)({
      providedProps: providedProps,
      state: state,
      dispatch: dispatch,
      onChangeContext: onChangeContext
    }),
    ref: refListBoxContainer,
    role: "listbox"
  }), children);
}

Content.displayName = "ListBox.Content";
Content.propTypes = {
  children: _propTypes["default"].node,
  onCancelFooter: _propTypes["default"].func
};
Content.defaultProps = {
  children: null,
  onCancelFooter: null
};
//# sourceMappingURL=Content.js.map